import { Modal as ModalModule } from 'common';
import CopyText from 'common/src/code/ui/CopyText.component';
import React, { useContext } from 'react';

const { ModalContext, Modal, ModalButtonActionType } = ModalModule;

interface GetUsernameModalData {
	username: string;
}

interface GetUsernameModalProps {
	modalId: string;
	data: GetUsernameModalData;
}

const GetUsernameModal = ({ modalId, data }: GetUsernameModalProps) => {
	const { username } = data;
	const { closeModal } = useContext(ModalContext);

	const onCloseButtonClick = () => {
		closeModal(modalId);
	};

	const closeButton = {
		type: ModalButtonActionType.Ok,
		text: 'Close',
		onClick: onCloseButtonClick,
		dataqa: 'get-username-close-button',
	};

	return (
		<Modal
			className="account-personal-contact-info get-username-modal"
			modalId={modalId}
			header="Get Username"
			primaryButton={closeButton}
			size="small"
		>
			<div className="p-grid">
				<div className="p-col-12">
					<p className="username-label">
						You can use the username below to access partner solutions:
					</p>
				</div>
				<div className="p-col-12">
					<CopyText text={username} copiedTextClassName="copied-text" />
				</div>
			</div>
		</Modal>
	);
};

export default GetUsernameModal;
